export default [
  {
    type: 'profile',
    Header: 'Prénom/Nom',
    accessor: 'name', // accessor is the "key" in the data
  },
  {
    type: 'information-italic-grey',
    Header: 'Groupe',
    accessor: 'groupName', // accessor is the "key" in the data
  },
  {
    type: 'information-italic-grey',
    Header: 'Date',
    fontWeight: 'italic',
    accessor: 'creationDate',
  },
  {
    type: 'request-icon',
    Header: 'Demande',
    accessor: 'request', // accessor is the "key" in the data
  },
  {
    type: 'contact-icon',
    Header: 'Contact',
    accessor: 'contact', // accessor is the "key" in the data
  },
  {
    type: 'payment_link',
    Header: 'Lien de paiement',
    accessor: 'paymentStatus', // accessor is the "key" in the data
  },
  {
    type: 'information-status',
    Header: 'Statut',
    accessor: 'status', // accessor is the "key" in the data
  },
  {
    type: ['delete-icon'],
    Header: 'Actions',
    accessor: 'actions',
  },
  {
    type: 'hidden',
    accessor: 'data',
  }
];
